import { render, staticRenderFns } from "./VCarousel.vue?vue&type=template&id=9acb8ed4"
import script from "./VCarousel.vue?vue&type=script&lang=ts"
export * from "./VCarousel.vue?vue&type=script&lang=ts"
import style0 from "./VCarousel.vue?vue&type=style&index=0&id=9acb8ed4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports